import { render, staticRenderFns } from "./TeacherCard.vue?vue&type=template&id=6f647e2d&scoped=true&"
import script from "./TeacherCard.vue?vue&type=script&lang=js&"
export * from "./TeacherCard.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCard.vue?vue&type=style&index=0&id=6f647e2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f647e2d",
  null
  
)

export default component.exports